import "./changepass.css";
import React, { Fragment, useState } from "react";
import apiEndPoint from "../../utils/apiEndPoint";
import { apiCall, failedMessage } from "../../utils/httpClient";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "../../utils/utils";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import Header from "../../layout/header";
import { Card, CardBody, CardHeader } from "reactstrap";

function ChangePassword() {
    const [isLoading, setLoading] = useState(false);
    const [passwordData, setPasswordData] = useState({
        password: '',
        cpassword: '',
    });
    const [errorMessage, setErrorMessage] = useState({});
    const navigate = useNavigate();
    const validation = () => {
        let isError = true;
        let errorMessage = {};
        if (isEmpty(passwordData?.oldPassword)) {
            isError = false;
            errorMessage["oldPassword"] = "Please enter old password";
        }
        if (isEmpty(passwordData?.password)) {
            isError = false;
            errorMessage["password"] = "Please enter password";
        }
        if (isEmpty(passwordData?.cpassword)) {
            isError = false;
            errorMessage["cpassword"] = "Please enter confirm password";
        } else if (passwordData?.password !== passwordData?.cpassword) {
            isError = false;
            errorMessage["cpassword"] = "Password and confirm password not match!";
        }

        setErrorMessage(errorMessage);
        return isError;
    };
    const handleChange = async () => {
        if (validation()) {
            setLoading(true)
            const params = {
                old_password: passwordData?.oldPassword,
                new_password: passwordData?.password,
            }
            const { data } = await apiCall('post', apiEndPoint.CHANGEPASSWORD, params);
            if (data.status !== 200) {
                failedMessage(data.message);
            } else {
                // successMessage(data.message)
                navigate('/accountsetting')
            }
            setLoading(false)
        }
    }
    return (
        <Fragment>
            {/* <Header /> */}
            <Container>
                <Row className="justify-content-md-center">
                    <Col xs lg="6">
                        <Card className="mt-4">
                            <CardHeader>
                                <div style={{ display: 'flex' }} className="align-items-center justify-content-between">
                                    <div lg="8">
                                        <h4>Change Password</h4>
                                    </div>
                                    <div lg="4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button onClick={() => navigate('/accountsetting')} className="back-btn">{'<'} Back</Button>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <small>Your new password must be different from previously used password.</small>
                                <form>
                                    <div className="form-group">
                                        <div className="row">

                                            <div className="col-lg-12 mt-adj">
                                                <div className="input-field-box">
                                                    <label>Enter Old Password :</label>
                                                    <input htmlFor="email" value={passwordData?.oldPassword} type="password" size="large"
                                                        onChange={(e) => setPasswordData({
                                                            ...passwordData,
                                                            oldPassword: e.target.value
                                                        })}
                                                        placeholder={"Enter Old Password"}
                                                        className={`${errorMessage.oldPassword ? "input-errmsg" : ""} form-control`} />
                                                    {errorMessage.oldPassword && <span className="er-msg-show">{errorMessage.oldPassword}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="input-field-box">
                                                    <label>Enter New Password :</label>
                                                    <input htmlFor="email" value={passwordData?.password} type="password" size="large"
                                                        onChange={(e) => setPasswordData({
                                                            ...passwordData,
                                                            password: e.target.value
                                                        })}
                                                        placeholder={"Enter New Password"}
                                                        className={`${errorMessage.password ? "input-errmsg" : ""} form-control`} />
                                                    {errorMessage.password && <span className="er-msg-show">{errorMessage.password}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="input-field-box">
                                                    <label>Confirm your Password :</label>
                                                    <input
                                                        placeholder="Confirm Password"
                                                        type="password"
                                                        value={passwordData?.cpassword} size="large"
                                                        onChange={(e) => setPasswordData({
                                                            ...passwordData,
                                                            cpassword: e.target.value
                                                        })}
                                                        className={`${errorMessage.cpassword ? 'input-errmsg' : ''} form-control`} />
                                                    {errorMessage.cpassword && <span className="er-msg-show">{errorMessage.cpassword}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sav-btn mt-adj">
                                            <button type="button" onClick={() => handleChange()} disabled={isLoading}>{isLoading ? <Spinner animation="border" size="sm" role="status" /> : 'Submit'}</button>
                                        </div>
                                    </div>
                                </form>
                               
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}

export default ChangePassword;